import { render, staticRenderFns } from "./tpla.vue?vue&type=template&id=02098de2&scoped=true&"
import script from "./tpla.vue?vue&type=script&lang=js&"
export * from "./tpla.vue?vue&type=script&lang=js&"
import style0 from "./tpla.vue?vue&type=style&index=0&id=02098de2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02098de2",
  null
  
)

export default component.exports